export default __webpack_public_path__ + "static/media/bobCaf.7c81c043.gif";